module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "place"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.place.name,
      "level": 2,
      "font": "oswald",
      "color": "yellow",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('large-picture', {
    attrs: {
      "src": _vm.place.picture,
      "alt": _vm.place.name
    }
  }), _vm._v(" "), _c('section', [_c('heading', {
    attrs: {
      "text": _vm.$t('encyclopedia.info'),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('place.description')))]), _vm._v(" "), (_vm.place.description) ? _c('div', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.place.description))]) : _c('div', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('place.address')))]), _vm._v(" "), (_vm.place.address) ? _c('div', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.place.address))]) : _c('div', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "website"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.website')))]), _vm._v(" "), (_vm.place.website) ? _c('a', {
    staticClass: "light",
    attrs: {
      "href": _vm.place.website
    }
  }, [_vm._v(_vm._s(_vm.getDomain(_vm.place.website)))]) : _c('div', {
    staticClass: "light"
  }, [_vm._v("N/A")])])])], 1), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-779f6284"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/Place.vue
// module id = 272
// module chunks = 0